module.exports = __webpack_public_path__ + "static/rec-logo-59667d7974828444b6ca859d691092fc.png";